import React, {Component} from 'react';
import '../../css/components/Menu.css';
import {NavLink} from "react-router-dom";

class Menu extends Component {

    internalLink(link) {
        return (
            <td key={"menu-" + link.title} className={"menu_cell"}>
                <div className="dropdown">
                    <NavLink className={"menu_link"} to={link.url}
                                activeClassName={"active_ml"}>{link.title}</NavLink>
                    <div className="dropdown-content">
                        {
                            link.sublinks.map(l =>
                                <NavLink className={"menu_sublink"}
                                    to={l.url}
                                    key={"menu-link-" + l.title}
                                    activeClassName={"active_sub_ml"}>
                                    {l.title}
                                </NavLink>
                            )
                        }
                    </div>
                </div>
            </td>
        );
    }

    externalLink(link) {
        return (
            <td key={"menu-" + link.title} className={"menu_cell"}>
                <div className="dropdown">
                    <a className={"menu_link"}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer">
                        {link.title}
                    </a>
                </div>
            </td>
        );
    }

    render() {
        return (
            <header>
                <div id={"menu_wrapper"}>
                    <table id={"menu_table"}>
                        <tbody>
                        <tr className={"menu_row"}>
                            {
                                this.props.links.map((link) => link.url.startsWith("http") ? this.externalLink(link) : this.internalLink(link))
                            }
                        </tr>
                        </tbody>
                    </table>
                </div>
            </header>
        );
    }
}

export default Menu;
